import { LocalDictionaryFactory } from '../../api/api.module'

import { DEVICE_SERVICE_NAME, DeviceService } from '../../../services/device'
import { DEPOSITORY_SERVICE_NAME, DEPOSITORY_MIN_STATES_SERVICE_NAME, DepositoryService, DepositoryMinStatesService } from '../../../services/depository'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $Q_SERVICE_NAME } from '../../../services/system'

import { LoggerService } from '../../common/common.module'

import { DepositoryDetailsDirectiveController, DepositoryDetailsScope } from './depositories-details.directive.controller'

import { DepositoryHelper } from '../depositories.helper'

//#region Asset Imports

import * as TEMPLATE from './depositories-details.tpl.html'

//#endregion


// Setup

export class DepositoryDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'logger',
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        DEVICE_SERVICE_NAME,
        DEPOSITORY_SERVICE_NAME,
        DEPOSITORY_MIN_STATES_SERVICE_NAME, (
            $scope: DepositoryDetailsScope,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            userSession: UserSessionService,
            deviceService: DeviceService,
            depositoryService: DepositoryService,
            depositoryMinStatesService: DepositoryMinStatesService
        ) => new DepositoryDetailsDirectiveController(
            $scope,
            $q,
            $timeout,
            logger,
            localDictionary,
            userSession,
            deviceService,
            depositoryService,
            depositoryMinStatesService,
            DepositoryHelper.REFERENCE_TYPE,
            DepositoryHelper.SIMAX_MODULE_NAME
        )]

    controllerAs = '$ctrl'

    template = TEMPLATE
}

// Setup End